module.exports = require('./helpers/bundle-url').getBundleURL('9pgM9') + "open-new-window-blue.37a14235.svg" + "?" + Date.now();